import {
    useDispatch as useReduxDispatch,
    useSelector as useReduxSelector
} from 'react-redux'
import { configureStore } from '@reduxjs/toolkit'
import { rootReducer } from './root-reducer'
import { api } from '../services/api/index.ts'
import { laravel_api } from 'services/laravel_api'

/**
 * Configures and exports the Redux store.
 *
 * @constant {object} store - The configured Redux store.
 * @property {function} reducer - The root reducer for the application state.
 * @property {boolean} devTools - Enables Redux DevTools if the environment variable
 * REACT_APP_ENABLE_REDUX_DEV_TOOLS is set to 'TRUE'.
 * @property {function} middleware - Customizes middleware by concatenating API middleware
 * to the default middleware.
 */
export const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.REACT_APP_ENABLE_REDUX_DEV_TOOLS === 'TRUE',
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat(api.middleware)
            .concat(laravel_api.middleware)
})

/**
 * Re-exports the `useReduxSelector` hook to be used as `useSelector` within React components.
 * This hook is used to select a part of the Redux state.
 */
export const useSelector = useReduxSelector

/**
 * Custom hook to access the Redux dispatch function.
 *
 * @returns {Function} The dispatch function from the Redux store.
 */
export const useDispatch = () => useReduxDispatch()
